<template>
  <span class="coming-soon-badge" :class="[`coming-soon-badge--${variant}`]">
    {{ label }}
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ComingSoonBadge',

  props: {
    variant: {
      type: String,
      default: 'floating',
      validator: (v: string) => ['floating', 'inline'].includes(v),
    },
  },

  setup() {
    const { t } = useI18n();
    return { label: t('comingSoon') };
  },
});
</script>

<style lang="scss" scoped>
.coming-soon-badge {
  font-size: 0.6rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #ffffff;
  background: linear-gradient(135deg, #8b5cf6, #6366f1);
  border-radius: 6px;
  white-space: nowrap;
  line-height: 1;
  pointer-events: none;

  &--floating {
    position: absolute;
    top: -7px;
    right: -7px;
    padding: 4px 8px;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.35);
    z-index: 1;
  }

  &--inline {
    display: inline-flex;
    align-items: center;
    padding: 2px 7px;
    margin-left: 6px;
    vertical-align: middle;
    font-size: 0.55rem;
  }
}
</style>
